module.exports = __webpack_public_path__ + "img/works_xikemu_dx_1.adad3d4e.png";